import { makeStyles } from 'tss-react/mui'
import { keyframes } from 'tss-react'

export default makeStyles()(theme => ({
  container: {
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    background: 'rgba(0, 0, 0, 0.04)',
    overflow: 'hidden',
    textAlign: 'center',
  },
  videoWrapper: {
    position: 'relative',
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
  video: {
    width: '100%',
    position: 'relative',
    zIndex: '2',
  },
  videoLoader: {
    position: 'absolute',
    left: 48,
    top: 'calc(50% - 8px)',
    width: 'calc(100% - 96px)',
    textAlign: 'center',
    zIndex: '1',
    color: 'rgba(0, 0, 0, 0.6)',
    animation: `${keyframes`
      from { opacity: 1, }
      to { opacity: 0.5, }
    `} 0.8s linear infinite alternate`,
  },
  dropHelperText: {
    textAlign: 'center',
    padding: theme.spacing(3),
  },
  error: {
    textAlign: 'center',
    marginTop: theme.spacing(2),
    color: theme.palette.error.main,
  },
}))
